import { applyMiddleware, createStore } from 'redux';
import logger from 'redux-logger';
import rootReducer from './rootReducer';
import { rootSaga } from './rootSaga';
import createSagaMiddleware from 'redux-saga';

// @ts-ignore
import persistStore from 'redux-persist/es/persistStore';
import {configureStore} from "@reduxjs/toolkit";

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
    reducer: rootReducer,
    // middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(logger),
    devTools: process.env.NODE_ENV !== 'production',
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({  serializableCheck: false }).concat(sagaMiddleware),
})


sagaMiddleware.run(rootSaga);
export const persistor = persistStore(store);

export default store;
